import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';

class MobileNav extends React.Component {

  state = {
    isMenuOpen: false,
  };

  // Toggle menu from hamburger
  handleMenuClick = () => {

    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));

    document.querySelectorAll('.menu-Bar').forEach((menuBar) => {
      menuBar.classList.toggle('open');
    });

    document.querySelectorAll('.menuWrap').forEach((menuWrap) => {
      menuWrap.classList.toggle('open');
    });

    document.body.classList.toggle('ovr-hiddn');

  };


  // Close menu when clicking actual links only
  handleLinkClick = () => {

    this.setState({ isMenuOpen: false });

    document.querySelectorAll('.menu-Bar').forEach((menuBar) => {
      menuBar.classList.remove('open');
    });

    document.querySelectorAll('.menuWrap').forEach((menuWrap) => {
      menuWrap.classList.remove('open');
    });

    document.body.classList.remove('ovr-hiddn');

  };


  render() {

    return (

      <div className='ctmNavMobile'>

        {/* Library Hours */}
        <div className="marquee">
          <ul>
            <li>
              <h6>
                <img
                  src={process.env.PUBLIC_URL + "/assets/img/open-hours-icon.svg?v=1.1.1"}
                  className="img-fluid"
                  alt=""
                />
                Library Hours
              </h6>
              <p>Mon to Fri 8:00 AM to 7:30 PM</p>
              <p>Working Saturday 8:00 AM to 5:00 PM</p>
            </li>
          </ul>
        </div>


        {/* Logo + Hamburger */}
        <div className='logoHumbergWrap'>

          <Link
            to="/"
            className='mobileLogo'
            onClick={this.handleLinkClick}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/img/responsive-logo.svg?v=1.1.1"}
              className="img-fluid responsive-logo"
              alt=""
            />
          </Link>


          <div
            className="menu-Bar"
            onClick={this.handleMenuClick}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>



        {/* Menu */}
        <div className="menuWrap">

          <div className="container">

            <div className="innerWrapMenu">


              {/* Home */}
              <Link to="/" onClick={this.handleLinkClick}>
                Home
              </Link>



              <Accordion alwaysOpen={false}>


                {/* About */}
                <Accordion.Item eventKey="0">

                  <Accordion.Header>
                    About
                  </Accordion.Header>

                  <Accordion.Body>

                    <ul>

                      <li>
                        <Link to="/library-hours" onClick={this.handleLinkClick}>
                          Library Hours
                        </Link>
                      </li>


                      <li className="submenu-title">
                        Patron/User Policies
                      </li>

                      <ul className="subItemsMenu">

                        <li>
                          <Link to="/borrowing-policies" onClick={this.handleLinkClick}>
                            Borrowing Policies
                          </Link>
                        </li>

                        <li>
                          <Link to="/computer-use-policy" onClick={this.handleLinkClick}>
                            Computer Use Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/discussion-rooms-policy" onClick={this.handleLinkClick}>
                            Discussion Rooms Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/Compliance" onClick={this.handleLinkClick}>
                            Compliance
                          </Link>
                        </li>

                      </ul>


                      <li>
                        <Link
                          to="/internship-and-student-employment-opportunities"
                          onClick={this.handleLinkClick}
                        >
                          Internship & Student Employment Opportunities
                        </Link>
                      </li>

                    </ul>

                  </Accordion.Body>

                </Accordion.Item>



                {/* Explore */}
                <Accordion.Item eventKey="1">

                  <Accordion.Header>
                    Explore
                  </Accordion.Header>

                  <Accordion.Body>

                    <ul>

                      <li>
                        <Link
                          to="/collaborative-working-and-learning-spaces"
                          onClick={this.handleLinkClick}
                        >
                          Collaborative Working and Learning Spaces
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/computer-and-technology"
                          onClick={this.handleLinkClick}
                        >
                          Computer and Technology (Equipment)
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/printing-scanning-and-photocopying"
                          onClick={this.handleLinkClick}
                        >
                          Printing, Scanning and Photocopying
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/library-services"
                          onClick={this.handleLinkClick}
                        >
                          Library Services
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/maker-space"
                          onClick={this.handleLinkClick}
                        >
                          Maker Space
                        </Link>
                      </li>


                    </ul>

                  </Accordion.Body>

                </Accordion.Item>



                {/* Find Resources */}
                <Accordion.Item eventKey="2">

                  <Accordion.Header>
                    Find Resources
                  </Accordion.Header>

                  <Accordion.Body>

                    <ul>

                      <li>
                        <a
                          href="https://catalog.habib.edu.pk/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={this.handleLinkClick}
                        >
                          Book/Catalog
                        </a>
                      </li>


                      <li>
                        <a
                          href="https://hira.habib.edu.pk/jspui/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={this.handleLinkClick}
                        >
                          HIRA (Habib Institutional Repository & Archive)
                        </a>
                      </li>


                      <li>
                        <a
                          href="https://habib.edu.pk/pakistanhistorybibliography/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={this.handleLinkClick}
                        >
                          Pakistan History Bibliography
                        </a>
                      </li>


                      <li>
                        <Link
                          to="/eresources-databases"
                          onClick={this.handleLinkClick}
                        >
                          E-Resources & Databases
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/free-open-access-resources"
                          onClick={this.handleLinkClick}
                        >
                          Free/Open Access Resource
                        </Link>
                      </li>


                      <li>
                        <a
                          href="https://libbyapp.com/library/habibuni"
                          target="_blank"
                          rel="noreferrer"
                          onClick={this.handleLinkClick}
                        >
                          Audio Books
                        </a>
                      </li>


                      <li>
                        <Link
                          to="/newspaper-magazine"
                          onClick={this.handleLinkClick}
                        >
                          Newspaper and Magazines
                        </Link>
                      </li>

                    </ul>

                  </Accordion.Body>

                </Accordion.Item>



                {/* Research Support */}
                <Accordion.Item eventKey="3">

                  <Accordion.Header>
                    Research Support
                  </Accordion.Header>

                  <Accordion.Body>

                    <ul>

                      <li>
                        <Link
                          to="/book-session"
                          onClick={this.handleLinkClick}
                        >
                          Book ‘One on one’ session
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/event-calendar"
                          onClick={this.handleLinkClick}
                        >
                          Upcoming Trainings/Workshops
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/self-learning-resources"
                          onClick={this.handleLinkClick}
                        >
                          Self-Learning Resources
                        </Link>
                      </li>

                    </ul>

                  </Accordion.Body>

                </Accordion.Item>


              </Accordion>



              {/* Quick Links */}

              <Link
                to="/resource-request"
                onClick={this.handleLinkClick}
              >
                Resource Request
              </Link>


              <Link
                to="/frequently-asked-questions"
                onClick={this.handleLinkClick}
              >
                FAQ's
              </Link>


              <Link
                to="/aska-librarian"
                onClick={this.handleLinkClick}
              >
                Contact
              </Link>


            </div>

          </div>

        </div>

      </div>

    );

  }

}

export default MobileNav;
